import api from '@/shared/api';
import type { DocumentDistributionGroupedData } from '../model/distribution.types';

export async function getGroupedDistributions(): Promise<DocumentDistributionGroupedData> {
  const response = await api.get('/document-distributions/grouped-by-prefix');
  return response.data.data;
}
